import { render } from "./DragZone.vue?vue&type=template&id=43621c3c&ts=true"
import script from "./DragZone.vue?vue&type=script&lang=ts"
export * from "./DragZone.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__